import { supabase } from '../lib/supabase';

class PlayerChangeNotificationService {
  constructor() {
    this.edgeFunctionUrl = null;
  }

  async initialize() {
    if (this.edgeFunctionUrl) return;
    
    try {
      const { data: { session } } = await supabase?.auth?.getSession();
      if (!session) {
        throw new Error('No active session');
      }

      const { data, error } = await supabase?.functions?.invoke('send-player-change-notification', {
        body: { test: true }
      });

      if (error) {
        console.warn('Edge function not available:', error);
      }
    } catch (error) {
      console.warn('Failed to initialize notification service:', error);
    }
  }

  async sendChangeNotification(playerData, changedFields, changeType = 'Single Edit') {
    try {
      await this.initialize();

      // Get notification recipients from user preferences or default admin emails
      const recipients = await this.getNotificationRecipients(playerData?.id);

      if (!recipients || recipients?.length === 0) {
        console.log('No recipients configured for player change notifications');
        return { success: true, message: 'No recipients configured' };
      }

      const { data, error } = await supabase?.functions?.invoke('send-player-change-notification', {
        body: {
          playerData: {
            id: playerData?.id,
            fullName: playerData?.fullName,
            primaryPosition: playerData?.primaryPosition,
            currentClub: playerData?.currentClub
          },
          changedFields,
          changeType,
          recipients
        }
      });

      if (error) {
        console.error('Failed to send notification:', error);
        return { success: false, error };
      }

      return { success: true, data };
    } catch (error) {
      console.error('Error sending change notification:', error);
      return { success: false, error };
    }
  }

  async getNotificationRecipients(playerId) {
    try {
      // Get admin users who should receive notifications
      const { data: adminUsers, error } = await supabase
        ?.from('user_profiles')
        ?.select('email')
        ?.eq('role', 'admin')
        ?.not('email', 'is', null);

      if (error) {
        console.error('Error fetching admin users:', error);
        return [];
      }

      return adminUsers?.map(user => user?.email)?.filter(email => email);
    } catch (error) {
      console.error('Error getting notification recipients:', error);
      return [];
    }
  }

  formatChangedFields(oldData, newData, fieldLabels) {
    const changes = [];
    
    Object.keys(newData)?.forEach(key => {
      if (oldData?.[key] !== newData?.[key] && key !== 'photoFile' && key !== 'oldPhotoPath') {
        changes?.push({
          field: key,
          label: fieldLabels?.[key] || key,
          oldValue: oldData?.[key],
          newValue: newData?.[key]
        });
      }
    });

    return changes;
  }
}

export const playerChangeNotificationService = new PlayerChangeNotificationService();